import {checkOrder, createOrder, fetchOrders, getOrder, updatePaymentMethodForOrder} from '../services/orders';

export const GET_ORDERS_REQUEST = 'GET_ORDERS_REQUEST';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILURE = 'GET_ORDERS_FAILURE';
export const CHECK_ORDER_REQUEST = 'CHECK_ORDER_REQUEST';
export const CHECK_ORDER_SUCCESS = 'CHECK_ORDER_SUCCESS';
export const CHECK_ORDER_FAILURE = 'CHECK_ORDER_FAILURE';
export const PLACE_ORDER_REQUEST = 'PLACE_ORDER_REQUEST';
export const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS';
export const PLACE_ORDER_FAILURE = 'PLACE_ORDER_FAILURE';
export const SET_DELIVERY_PLACE = 'SET_DELIVERY_PLACE';
export const GET_ORDER_DETAILS_REQUEST = 'GET_ORDER_DETAILS_REQUEST';
export const GET_ORDER_DETAILS_SUCCESS = 'GET_ORDER_DETAILS_SUCCESS';
export const GET_ORDER_DETAILS_FAILURE = 'GET_ORDER_DETAILS_FAILURE';

export const SET_DELIVERY_RATING_REQUEST = 'SET_DELIVERY_RATING_REQUEST';
export const SET_DELIVERY_RATING_SUCESS = 'SET_DELIVERY_RATING_SUCESS';
export const SET_DELIVERY_RATING_FAILURE = 'SET_DELIVERY_RATING_FAILURE';

export const SHIPPO_SHIPMENT_REQUEST = 'SHIPPO_SHIPMENT_REQUEST';
export const SHIPPO_SHIPMENT_SUCCESS = 'SHIPPO_SHIPMENT_SUCCESS';
export const SHIPPO_SHIPMENT_FAILURE = 'SHIPPO_SHIPMENT_FAILURE';

export const UPDATE_PAYMENT_METHOD_ORDER_REQUEST = 'UPDATE_PAYMENT_METHOD_ORDER_REQUEST';
export const UPDATE_PAYMENT_METHOD_ORDER_SUCCESS = 'UPDATE_PAYMENT_METHOD_ORDER_SUCCESS';
export const UPDATE_PAYMENT_METHOD_ORDER_FAILURE = 'UPDATE_PAYMENT_METHOD_ORDER_FAILURE';

import { addRating } from '../services/rating';
import { getShipment } from '../services/shippo';

export function createTempOrder(data, callback) {
  return dispatch => {
    dispatch({type: CHECK_ORDER_REQUEST})
    return checkOrder(data).then(res => {
      dispatch({type: CHECK_ORDER_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(err => {
      dispatch({type: CHECK_ORDER_FAILURE, payload: err})
      if (callback) {
        callback({status: false, data: err})
      }
    });
  };
}

export function placeOrder(data, callback) {
  return dispatch => {
    dispatch({type: PLACE_ORDER_REQUEST})
    return createOrder(data).then(res => {
      dispatch({type: PLACE_ORDER_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(err => {
      dispatch({type: PLACE_ORDER_FAILURE, payload: err})
      if (callback) {
        callback({status: false, data: err})
      }
    });
  };
}

export function getOrders(callback) {
  return dispatch => {
    dispatch({type: GET_ORDERS_REQUEST})
    return fetchOrders().then(res => {
      dispatch({type: GET_ORDERS_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(err => {
      dispatch({type: GET_ORDERS_FAILURE, payload: err})
      if (callback) {
        callback({status: false, data: err})
      }
    });
  };
}

export function getOrderDetails(orderId, callback) {

  return dispatch => {
    dispatch({type: GET_ORDER_DETAILS_REQUEST})
    return getOrder(orderId).then(res => {
      dispatch({type: GET_ORDER_DETAILS_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(err => {
      dispatch({type: GET_ORDER_DETAILS_FAILURE, payload: err})
      if (callback) {
        callback({status: false, data: err})
      }
    });
  };
}


export function setDeliveryPlace(data) {
  return {
    type: SET_DELIVERY_PLACE,
    payload: data
  }
}

export function setRating(data, callback) {
  return dispatch => {
    dispatch({ type: SET_DELIVERY_RATING_REQUEST });
    return addRating(data).then(res => {
      dispatch({ type: SET_DELIVERY_RATING_SUCESS, payload: res});
      if(callback){
        callback({ status: true, data: res });
      }
    }).catch(error => {
      dispatch({ type: SET_DELIVERY_RATING_FAILURE, payload: error.error});
      if (callback) {
        callback({ status: false, data: error.error });
      }
    });
  };
}

export function shipporShipment(data, callback){
  return dispatch => {
    dispatch({ type: SHIPPO_SHIPMENT_REQUEST });
    return getShipment(data).then(res => {
      dispatch({ type: SHIPPO_SHIPMENT_SUCCESS, payload: res});
      if(callback){
        callback({ status: true, data: res });
      }
    }).catch(error => {
      dispatch({ type: SHIPPO_SHIPMENT_FAILURE, payload: error.error});
      if (callback) {
        callback({ status: false, data: error.error });
      }
    });
  };
}

export function updatePaymentForOrder(data, callback) {
  return dispatch => {
    dispatch({type: UPDATE_PAYMENT_METHOD_ORDER_REQUEST})
    return updatePaymentMethodForOrder(data).then(res => {
      dispatch({type: UPDATE_PAYMENT_METHOD_ORDER_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(err => {
      dispatch({type: UPDATE_PAYMENT_METHOD_ORDER_FAILURE, payload: err})
      if (callback) {
        callback({status: false, data: err})
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/ordersActions.js